import e from "react";
import n from "dequal";

var r,
    t = function t(e) {
  return function (n) {
    return Promise.resolve(e.fn.apply(e, n.data[0])).then(function (n) {
      var r,
          t = "auto" === e.transferable && (r = n, "ArrayBuffer" in self && r instanceof ArrayBuffer || "MessagePort" in self && r instanceof MessagePort || "ImageBitmap" in self && r instanceof ImageBitmap || "OffscreenCanvas" in self && r instanceof OffscreenCanvas) ? [n] : [];
      postMessage(["SUCCESS", n], t);
    }).catch(function (e) {
      postMessage(["ERROR", e]);
    });
  };
},
    a = function a(e, n, r) {
  var a = "\n    " + function (e) {
    return 0 === e.length ? "" : "importScripts(" + e.map(function (e) {
      return "'" + e + "'";
    }).toString() + ")";
  }(n) + ";\n    onmessage=(" + t + ")({\n      fn: (" + e + "),\n      transferable: '" + r + "'\n    })\n  ",
      o = new Blob([a], {
    type: "text/javascript"
  });

  return URL.createObjectURL(o);
};

!function (e) {
  e.PENDING = "PENDING", e.SUCCESS = "SUCCESS", e.RUNNING = "RUNNING", e.ERROR = "ERROR", e.TIMEOUT_EXPIRED = "TIMEOUT_EXPIRED";
}(r || (r = {}));
var o,
    u = r;
!function (e) {
  e.AUTO = "auto", e.NONE = "none";
}(o || (o = {}));

var i = {
  timeout: void 0,
  remoteDependencies: [],
  autoTerminate: !0,
  transferable: o.AUTO
},
    c = function c(r, t) {
  void 0 === t && (t = i);
  var c,
      s,
      f,
      l = e.useState(u.PENDING),
      m = l[0],
      v = l[1],
      R = e.useRef(),
      d = e.useRef(!1),
      p = e.useRef({}),
      E = e.useRef(),
      w = e.useCallback(function (e) {
    d.current = e === u.RUNNING, v(e);
  }, []),
      C = e.useCallback(function () {
    var e;
    null !== (e = R.current) && void 0 !== e && e._url && (R.current.terminate(), URL.revokeObjectURL(R.current._url), p.current = {}, R.current = void 0, window.clearTimeout(E.current));
  }, []),
      N = e.useCallback(function (e) {
    (null != t.autoTerminate ? t.autoTerminate : i.autoTerminate) && C(), w(e);
  }, [t.autoTerminate, C, w]),
      T = (c = function c() {
    var e = t.remoteDependencies,
        n = t.timeout,
        o = void 0 === n ? i.timeout : n,
        c = t.transferable,
        s = a(r, void 0 === e ? i.remoteDependencies : e, void 0 === c ? i.transferable : c),
        f = new Worker(s);
    return f._url = s, f.onmessage = function (e) {
      var n,
          r,
          t,
          a,
          o = e.data,
          i = o[1];

      switch (o[0]) {
        case u.SUCCESS:
          null === (n = (r = p.current).resolve) || void 0 === n || n.call(r, i), N(u.SUCCESS);
          break;

        default:
          null === (t = (a = p.current).reject) || void 0 === t || t.call(a, i), N(u.ERROR);
      }
    }, f.onerror = function (e) {
      var n, r;
      null === (n = (r = p.current).reject) || void 0 === n || n.call(r, e), N(u.ERROR);
    }, o && (E.current = window.setTimeout(function () {
      C(), w(u.TIMEOUT_EXPIRED);
    }, o)), f;
  }, f = e.useRef(s = [r, t, C]), n(f.current, s) || (f.current = s), e.useCallback(c, f.current)),
      U = e.useCallback(function () {
    var e = [].slice.call(arguments),
        n = t,
        r = n.transferable,
        a = void 0 === r ? i.transferable : r;
    return new Promise(function (n, r) {
      var t, i;
      p.current = ((t = {}).resolve = n, t.reject = r, t);
      var c = a === o.AUTO ? e.filter(function (e) {
        return "ArrayBuffer" in window && e instanceof ArrayBuffer || "MessagePort" in window && e instanceof MessagePort || "ImageBitmap" in window && e instanceof ImageBitmap || "OffscreenCanvas" in window && e instanceof OffscreenCanvas;
      }) : [];
      null === (i = R.current) || void 0 === i || i.postMessage([[].concat(e)], c), w(u.RUNNING);
    });
  }, [w]),
      b = e.useCallback(function () {
    var e = null != t.autoTerminate ? t.autoTerminate : i.autoTerminate;
    return d.current ? (console.error("[useWorker] You can only run one instance of the worker at a time, if you want to run more than one in parallel, create another instance with the hook useWorker(). Read more: https://github.com/alewin/useWorker"), Promise.reject()) : (!e && R.current || (R.current = T()), U.apply(void 0, [].slice.call(arguments)));
  }, [t.autoTerminate, T, U]),
      O = {
    status: m,
    kill: C
  };
  return e.useEffect(function () {
    return function () {
      C();
    };
  }, [C]), [b, O];
};

export { r as WORKER_STATUS, c as useWorker };